import { z } from "zod"

export const ProgramTrialSubscriptionDtoSchema = z
  .object({
    startDate: z.string(),
    endDate: z.string(),
  })
  .meta({ id: "ProgramTrialSubscriptionDtoSchema" })

export type ProgramTrialSubscriptionDto = z.infer<typeof ProgramTrialSubscriptionDtoSchema>
